import { render, staticRenderFns } from "./NextPageLink.vue?vue&type=template&id=4fb88788"
import script from "./NextPageLink.vue?vue&type=script&lang=js"
export * from "./NextPageLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports